
import { Component, Inject, Optional } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { DialogData, XtDialogComponent } from '@xt/ui-kit';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { ButtonModule } from '@shared/components/atoms/button/button.module';

@Component({
  selector: 'xt-portal-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  standalone: true,
  imports: [
    ButtonModule,
    MatDialogModule,
    MatIconModule,
    TranslocoModule,
    XtDialogComponent
],
})
export class ConfirmDialogComponent {
  dialogConfig: DialogData;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.dialogConfig = {
      title: 'app.labels.hint',
      contentTitle: data.title,
      content: data.content,
      cancelButtonLabel: this.data.cancelBtnText,
      cancelButtonValue: false,
      confirmButtonLabel: this.data.confirmBtnText,
      confirmButtonValue: true,
    };
  }
}
